import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { UsersService } from 'src/app/private/services/users.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-reset-password',
  imports: [SharedModule],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {

  @Output() closeDialog = new EventEmitter<any>();
  @Input() userDataToEdit: any = {};

  constructor(
    private api : UsersService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  newPassword = '';
  isLoading = false;

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  saveNewPassword() {
    this.isLoading = true;
    const payload = {
      user_id: this.userDataToEdit.user_id,
      organization_id: this.localStorage.getOrganizationId(),
      password: this.newPassword
    }
    this.api.updateUser(payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Password updated successfully' });
        this.handleCloseDialog();
      },
      error: (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update password' });
        this.isLoading = false;
      }
    })
  }
}
